import {ToastType} from '@Components/toast/toast.types';

export const INVALID_TARGET_ERROR = 'Invalid target position';

export const showWarningToast = (message: string): void => {
  window.PMW.showToast({duration: 3000, title: message, type: ToastType.WARNING});
};
